import React, { useEffect, useState } from "react";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";

import { CloseIcon } from "@components/Icons";

import { IReadConfirmation } from "../../model";
import { formatReadDate } from "../table/table.helpers";

interface Props {
  notificationId: string | number;
  onRead: (uuid: string | number) => Promise<IReadConfirmation[]>;
  onClose: () => void;
}

const ReadConfirmationModal: React.FC<Props> = ({
  notificationId,
  onRead,
  onClose,
}) => {
  const [reads, setReads] = useState<IReadConfirmation[]>([]);

  useEffect(() => {
    const load = async () => {
      const result = await onRead(notificationId);
      setReads(result || []);
    };

    load();
  }, [notificationId, onRead]);

  return (
    <Dialog
      open
      onClose={() => onClose()}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          p: 2,
        }}
      >
        <Typography sx={{ fontSize: 18, fontWeight: 600, color: "#333333" }}>
          Confirmação de leitura <strong> #{`${notificationId}`}</strong>
        </Typography>

        <IconButton
          aria-label="fechar"
          onClick={() => onClose()}
          size="small"
          sx={{ color: "#4F4F4F" }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{
          mt: 1,
          pt: 2,
          pb: 3,
          px: 3,
        }}
      >
        {reads?.length === 0 ? (
          <Typography sx={{ fontSize: 14, color: "#4F4F4F" }}>
            Nenhuma leitura registrada ainda.
          </Typography>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}
          >
            {reads.map((read, index) => (
              <Box
                key={`${read.email}-${index}`}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  fontSize: 14,
                }}
              >
                <Typography sx={{ color: "#4F4F4F" }}>
                  {read.name} - {read.email}
                </Typography>

                <Typography
                  sx={{
                    color: "#00A650",
                    fontWeight: 500,
                    whiteSpace: "nowrap",
                  }}
                >
                  {formatReadDate(read.readAt)}
                </Typography>
              </Box>
            ))}
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ReadConfirmationModal;
